import React from 'react';
import { motion } from 'framer-motion';
import { ChefHat, Bath, Sofa, Home } from 'lucide-react';
const services = [{
  title: 'Kitchen Remodeling',
  description: 'Custom kitchen designs built for style and function.',
  icon: ChefHat
}, {
  title: 'Bathroom Remodeling',
  description: 'Modern bathroom upgrades from tile to fixtures.',
  icon: Bath
}, {
  title: 'Living Room & Interior',
  description: 'Open-concept layouts and refined interiors.',
  icon: Sofa
}, {
  title: 'Full Home Improvements',
  description: 'Complete remodels from foundation to finish.',
  icon: Home
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-66">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-68">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-69">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto" data-id="element-70"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-71">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center group" data-id="element-72">
              <div className="w-20 h-20 bg-brand-light rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-accent group-hover:text-white transition-colors duration-300 text-brand-dark" data-id="element-73">
                <service.icon size={32} strokeWidth={1.5} data-id="element-74" />
              </div>
              <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-75">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm" data-id="element-76">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}